import {Injectable} from '@angular/core';
import {SysConfigService} from './sys-config.service';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {SubSectionDTO} from '../dto/sub-section.model';
import {Observable} from 'rxjs/internal/Observable';
import {AppConfig} from '../common/app.config';

@Injectable({
  providedIn: 'root'
})
export class SubSectionService {
  public BASE_URL = this.appConfig.getConfig('BASE_URL') + 'api/';

  private headers = new HttpHeaders({
    'Content-Type': 'application/json; charset=utf-8'
  });


  constructor(private httpClient: HttpClient, private appConfig: AppConfig) {
  }

  /** Get All Sub Sections Details **/
  getAllSubSections(): Observable<Array<SubSectionDTO>> {
    return this.httpClient.get<Array<SubSectionDTO>>(this.BASE_URL + 'sub-section' + "/all")
  }
}
